import {
  TLBaseShape,
  RecordProps,
  T,
  BoundsSnapGeometry,
  Rectangle2d,
  HTMLContainer,
  BaseBoxShapeUtil,
} from "@tldraw/tldraw";

type FormatUtilType = TLBaseShape<
  "format",
  {
    w: number;
    h: number;
    fill: string;
  }
>;

export class FormatUtilFront extends BaseBoxShapeUtil<FormatUtilType> {
  static type = "format" as const;
  static props: RecordProps<FormatUtilType> = {
    w: T.number,
    h: T.number,
    fill: T.string,
  };

  mm = 5;

  isAspectRatioLocked(_shape: FormatUtilType): boolean {
    return true;
  }

  getDefaultProps(): FormatUtilType["props"] {
    return {
      w: 0,
      h: 0,
      fill: "#ffffff",
    };
  }

  getBoundsSnapGeometry(shape: FormatUtilType): BoundsSnapGeometry {
    return new Rectangle2d({
      width: shape.props.w,
      height: shape.props.h,
      isFilled: true,
      x: 0,
      y: 0,
    });
  }

  component(shape: FormatUtilType) {
    const title = shape.id.replace(/^shape:/, "");

    return (
      <HTMLContainer
        id={shape.id}
        style={{ backgroundColor: shape.props.fill }}
        className="relative flex items-center justify-center"
      ></HTMLContainer>
    );
  }

  indicator(shape: FormatUtilType) {
    return this.component(shape);
  }
}
